export const PAGE_SIZE = 10;
export const MODAL_PAGE_SIZE = 8;
export const TENANT_MISMATCH_CODE = "VENUE_GROUP_TENANT_MISMATCH";

export const memberLimitTooltip = (max) =>
  max === 1
    ? "One member per venue group for now."
    : `Up to ${max} members per venue group for now.`;

export const ROLES = [
  { value: "AA", label: "Additional Angle (AA)" },
  { value: "OCR", label: "OCR" },
];

export const SEARCH_BY_OPTIONS = [
  { name: "Name", value: "name" },
  { name: "Tenant", value: "tenant" },
  { name: "Product Type", value: "productType" },
  { name: "Venue Name", value: "venueName" },
  { name: "Venue ID", value: "venueId" },
];

export const PICKER_SEARCH_BY_OPTIONS = SEARCH_BY_OPTIONS.map((option) =>
  option.value === "name" ? { name: "Name", value: "name,systemId,dongleId" } : { ...option },
);

export const ANCHOR_PRODUCT_TYPES = [{ id: "SP2", title: "SP2" }];

export const MEMBER_PRODUCT_TYPES = [
  { id: "AA", title: "AA" },
  { id: "OCR", title: "OCR" },
];

export const getVenueGroupsTabIndex = (isBillingOrSuperAdmin) => (isBillingOrSuperAdmin ? 2 : 1);

export const roleShortLabel = (role) => (role === "AA" ? "Additional Angle" : role);

export const roleLabel = (role) => ROLES.find((item) => item.value === role)?.label || role;

export const memberCountLabel = (count) => `${count} ${count === 1 ? "member" : "members"}`;

const joinNames = (names) => names.join(", ");

export const describeMembers = (members) =>
  joinNames(members.map((member) => `${member.name} (${roleShortLabel(member.role)})`));

export const buildGroupToast = (title, anchorName, members) => ({
  title,
  message: `${describeMembers(members)} now ${
    members.length === 1 ? "works" : "work"
  } with ${anchorName}.`,
});

export const buildCreatedToast = (anchorName, members) =>
  buildGroupToast("Venue group created", anchorName, members);

export const buildSavedToast = (anchorName, members) =>
  buildGroupToast("Venue group saved", anchorName, members);

export const buildUngroupedToast = (anchorName, members) => ({
  title: "Venue group ungrouped",
  message: `${anchorName} works as a single camera again. ${joinNames(
    members.map((member) => member.name),
  )} ${members.length === 1 ? "is" : "are"} free.`,
});

export const buildUngroupErrorToast = (anchorName, members) => ({
  title: "Couldn't ungroup",
  message: `${anchorName} and ${joinNames(
    members.map((member) => member.name),
  )} are still grouped. Try again.`,
});

export const CREATE_ERROR_TOAST = {
  title: "Couldn't create venue group",
  message: "Nothing was changed. Try again.",
};

export const CREATE_TENANT_ERROR_TOAST = {
  title: "Couldn't create venue group",
  message: "The anchor and members must belong to one tenant.",
};

export const SAVE_ERROR_TOAST = {
  title: "Couldn't save venue group",
  message: "Nothing was changed. Try again.",
};

export const isTenantMismatchError = (error) => {
  const data = error?.data;

  return (
    data?.code === TENANT_MISMATCH_CODE ||
    Boolean(data?.errors?.some((item) => item.code === TENANT_MISMATCH_CODE))
  );
};

export const toMemberPayload = (members) => members.map(({ id, role }) => ({ id, role }));

export const sameMembers = (first, second) => {
  const key = (members) =>
    members
      .map(({ id, role }) => `${id}:${role}`)
      .sort()
      .join("|");

  return key(first) === key(second);
};
